/**
 * Example action that shows a notification
 * This action can be triggered with: window.addEventListener('arc:action:OpenDetailsDrawer')
 */

export const runOpenDetailsDrawer = async (data = {}) => {
    try {
        const {
            message = 'Hello from the event system!',
            type = 'info',
            duration = 3000
        } = data;

        // Slide in the details drawer if it exists
        const drawer = document.getElementById('details-drawer');
        if (drawer) {
            drawer.style.position = 'fixed';
            drawer.style.top = '0';
            drawer.style.right = '0';
            drawer.style.height = '100vh';
            drawer.style.width = drawer.style.width || '400px';
            drawer.style.maxWidth = '100vw';
            drawer.style.background = '#fff';
            drawer.style.boxShadow = '0 0 24px rgba(0,0,0,0.15)';
            drawer.style.zIndex = '10001';
            drawer.style.transform = 'translateX(100%)';
            drawer.style.transition = 'transform 0.4s cubic-bezier(.4,0,.2,1)';
            drawer.style.display = 'block';
            drawer.style.zIndex = '999999';
            setTimeout(() => {
                drawer.style.transform = 'translateX(0)';
                drawer.setAttribute('aria-hidden', 'false');
                drawer.setAttribute('tabindex', '0');
                drawer.focus && drawer.focus();
            }, 10);
        }

        return {
            success: true,
            message: 'Notification displayed',
            data: { message, type, duration }
        };

    } catch (error) {
        console.error('Error showing notification:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

export default runOpenDetailsDrawer;
